import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { translate } from "../../translations/index.js";
import { ChangeEvent, useState } from "react";
import APIclient from "../../api-client/index.js";

export default function ResetPasswordInit() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [, setError] = useState("");

  async function handleSubmit() {
    setError("");
    try {
      await APIclient.auth.passwords.create(email);
      setSuccess(true);
    } catch {
      setError("Could not send password reset e-mail.");
    }
  }

  return (
    <div className="container container--max-xs">
      <h1>{translate("auth.resetPassword.new.title")}</h1>
      {!success ? (
        <ValidatorForm
          onSubmit={handleSubmit}
          // eslint-disable-next-line no-console
          onError={(errors) => console.log(errors)}
        >
          <TextValidator
            name="email"
            label={translate("auth.resetPassword.new.email.label")}
            placeholder={translate("auth.resetPassword.new.email.placeholder")}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
            value={email}
            fullWidth
            className="normal-input"
            validators={["required", "isEmail"]}
            errorMessages={[
              translate("form_validation_required"),
              translate("form_validation_email"),
            ]}
          />
          <button className="button" type="submit">
            {translate("auth.resetPassword.new.submit")}
          </button>
        </ValidatorForm>
      ) : (
        <p>{translate("auth.resetPassword.new.successMessage", { email })}</p>
      )}
    </div>
  );
}
